import React from 'react';

/**
 * RevivalSMP at night: the cathedral spawn, its teal crystal trees and
 * graveyard, and a player walking up with their pets. Generated in the
 * Petlings voxel style (petlings-ios-app/scripts/pet-art/gen_scenes.py).
 */
export default function RevivalScene() {
  return (
    <img
      src="/servers/revivalsmp-scene.webp"
      alt="RevivalSMP's gothic cathedral spawn at night, with a player and their pets on the plaza"
      className="server-scene"
      width="1216"
      height="816"
      loading="lazy"
    />
  );
}
